export interface CreditApplicationResponseType {
  isSuccess: boolean;
  statusCode: number;
  additionalInfo: string;
  message: string;
  data?: Data;
}

export interface Data {
  compassOpptId?: any;
  creditFormId?: string;
  creditAppId?: string;
  creditApplicationStatus?: CreditApplicationStatusTypeEnum;
  step?: number;
  success?: boolean;
  errorCodes?: any[];
  CreditAppId?:string;
  OpptId?: any;
  CreditApplicationStatus?: CreditApplicationStatusTypeEnum;
}

export enum CreditApplicationStatusTypeEnum {
    NotStarted = 0,
    ShortFormSubmitted,
    PreScreenLeadSubmissionCompleted,
    CreditAppLeadSubmissionCompleted,
    LenderSubmissionRequested,
    LenderLeadSubmissionCompleted,
    InProgress,
    Submitted,
    Pending,
    Approved,
    Declined,
    Error
}

export interface BankResponseType {
  isSuccess: boolean;
  statusCode: number;
  additionalInfo: string;
  message: string;
  data?: Data;
}
